@if (!isDateBadge) {
  <span
    [ngStyle]="cssStyle"
    [style.background-color]="backgroundColor"
    [style.border-color]="borderColor"
    [style.border-radius]="borderRadius"
    [style.bottom]="positionBottom"
    [style.color]="color"
    [style.font-size]="fontSize"
    [style.height]="height"
    [style.left]="positionLeft"
    [style.position]="positionStyle"
    [style.right]="positionRight"
    [style.top]="positionTop"
    [style.width]="width"
    [style.z-index]="zIndex"
    class="badge badge-{{ type }}"
  >
    {{ text }}
  </span>
} @else {
  <span
    [ngStyle]="cssStyle"
    [style.background-color]="backgroundColor"
    [style.border-color]="borderColor"
    [style.border-radius]="borderRadius"
    [style.bottom]="positionBottom"
    [style.color]="color"
    [style.font-size]="fontSize"
    [style.height]="height"
    [style.left]="positionLeft"
    [style.position]="positionStyle"
    [style.right]="positionRight"
    [style.top]="positionTop"
    [style.width]="width"
    class="date-badge"
  >
    <span class="month">{{ dateText?.month || '--' }}</span> <br />
    <span class="day mt-1">{{ dateText?.day || '--' }}</span>
  </span>
}
